import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d5901c80&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5901c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5901c80')) {
      api.createRecord('d5901c80', component.options)
    } else {
      api.reload('d5901c80', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d5901c80&scoped=true&", function () {
      api.rerender('d5901c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ash9XZ3QUqes/JS/comp/SearchFilterTokens.vue"
export default component.exports